import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminReports() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/reports/sellers")
      .then(({ data }) => setItems(data))
      .catch((err) => console.warn(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="font-mono-b p-6" data-testid="rep-loading">Loading...</p>;

  if (items.length === 0) return <p className="font-mono-b p-8 text-center border-2 border-dashed border-black">No seller reports.</p>;

  return (
    <div className="space-y-3" data-testid="admin-reports">
      {items.map((r) => (
        <div key={r.report_id} className="bg-white border-2 border-black brutal-shadow-sm p-4" data-testid={`rep-${r.report_id}`}>
          <div className="flex justify-between flex-wrap gap-2">
            <div>
              <p className="font-mono-b text-xs text-black/60">Report {r.report_id}</p>
              <p className="font-display text-lg">Seller {r.seller_id?.slice(-8)} reported by {r.reporter_email}</p>
              <p className="font-mono-b text-xs mt-1"><b>{r.reason?.toUpperCase()}</b> · {r.description}</p>
              <p className="font-mono-b text-[10px] text-black/50 mt-1">{new Date(r.created_at).toLocaleString()}</p>
            </div>
            <span className={`sticker text-[10px] ${r.status === "open" ? "pink" : ""}`}>{r.status?.toUpperCase()}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
